import { Box, FormControl, FormHelperText, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';

const SelectorBox = ({
  title,
  options,
  currentOption,
  onSelection,
  helperText,
}) => {

  const [selectedOption, setSelectedOption] = useState("");

  function handleSelection(event) {
    console.log(event.target.value);
    setSelectedOption(event.target.value);
    // onSelection(event.target.value);
  }

  useEffect(() => {
    if (currentOption) {
      console.log(currentOption);
      setSelectedOption(currentOption);
    } else {
      setSelectedOption("");
    }
  }, [currentOption]);

  return (
    <Box sx={{
      display: "flex",
      flexDirection: "column",
      width: "100%",
      // gap: 1,
      // border: 1,
    }}>
      <Typography sx={{
        paddingLeft: "8px"
      }}>
        {title}
      </Typography>

      <FormControl fullWidth>
        <Select
          defaultValue={currentOption}
          value={selectedOption}
          onChange={handleSelection}
        // displayEmpty
        // inputProps={{ 'aria-label': 'Without label' }}
        >
          {
            options?.map((option, index) => {
              return (
                <MenuItem
                  key={index}
                  value={option?.name}
                >
                  {option.name}
                </MenuItem>
              )
            })
          }
        </Select>
        {helperText &&
          <FormHelperText>{helperText}</FormHelperText>
        }
      </FormControl>
    </Box>
  )
}

export default SelectorBox;